export default __webpack_public_path__ + "static/media/logo.2aa6ff65.png";